app.directive('backButton', ["$state", function ($state) {
    return {
        restrict: 'A',

        link: function (scope, element, attrs) {
            element.bind('click', goBack);

            function goBack(e) {
                if($state.params.modal === "1"){
                    if(["BUTTON", "INPUT", "SELECT", "A"].indexOf(e.target.nodeName) !== -1){
                        return;
                    }
                    // console.log(e);

                    history.back();
                    scope.$apply();
                }
            }
        }
    }
}]);